import { NavigationProgress } from '@repo/ui/components/ui/navigation-progress';
import { Toaster } from '@repo/ui/components/ui/sonner';
import type { QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { createRootRouteWithContext, HeadContent, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { RoleBadge } from '@/components/role-badge';
import { CookieConsent } from '@/features/cookie-consent';
import { GeneralError } from '@/features/errors/general-error';
import { NotFoundError } from '@/features/errors/not-found-error';

const DEFAULT_TITLE = 'promote.fun - Post Content, Get paid.';
const DEFAULT_DESCRIPTION = 'Turn your content distribution into revenue. Creators get paid for performance, brands get authentic reach.';

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
    head: () => ({
        meta: [{ title: DEFAULT_TITLE }, { name: 'description', content: DEFAULT_DESCRIPTION }],
    }),
    component: () => {
        return (
            <>
                <HeadContent />
                <NavigationProgress />
                <Outlet />
                <CookieConsent />
                <Toaster duration={5000} richColors />
                <RoleBadge />
                {import.meta.env.MODE === 'development' && (
                    <>
                        <ReactQueryDevtools buttonPosition='bottom-left' />
                        <TanStackRouterDevtools position='bottom-left' />
                    </>
                )}
            </>
        );
    },
    notFoundComponent: NotFoundError,
    errorComponent: GeneralError,
});
